<template>
  <BaseCard :title="'Eagle Project for LCA'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Project Manager & Leader</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">April 2022 - August 2022</h5>
      </div>
      <p class="text-center items-center pl-4 pr-4">
        Service revamp of gym/CYO entrances to Lakewood Catholic Academy<br>
        All new shrubs, perennials, mulch, bench area with gravel, and flowers<br>
        Planned, fundraised, lead, and reported by me<br>
        <a href="https://drive.google.com/drive/folders/1PQ0kxLRNEFaV2E9w1UQO3OjVbdjeVT2S?usp=sharing" target="_blank" class="link-in-text">Photos!</a><br>
      </p>
      <span class="grid lg:grid-cols-2 gap-12 place-items-center overflow-hidden">
        <img class="w-full h-auto rounded-lg hidden lg:block cursor-pointer" :src="EPShrubs" @click="openImageMenu(EPShrubs, 'Eagle Project Shrubs', $event.currentTarget)">
        <img class="w-full h-auto rounded-lg cursor-pointer" :src="EPBenches" @click="openImageMenu(EPBenches, 'Eagle Project Benches', $event.currentTarget)">
      </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import EPShrubs from '@/assets/Projects/EagleProjectPhotos/EPShrubs.png';
import EPBenches from '@/assets/Projects/EagleProjectPhotos/EPBenches.png';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>